module.exports = __webpack_public_path__ + "public/img/Membuat Website Toko Online.c0192dd1.png";